import React, { useState } from 'react';

function Feedback() {
  const [text, setText] = useState('');
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!text.trim()) return;
    setSent(true);
    setTimeout(() => {
      setText('');
      setEmail('');
      setSent(false);
    }, 3000);
  };

  return (
    <div style={{ maxWidth: 500, margin: '0 auto' }}>
      <h2>📮 Обратная связь</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Нашли ошибку или есть предложение? Напишите нам — мы быстро исправим.
      </p>

      {sent ? (
        <div style={{ padding: 20, background: '#10B981', color: '#fff', borderRadius: 8, textAlign: 'center' }}>
          ✅ Спасибо! Ваше сообщение отправлено.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <input
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Ваш email (необязательно)"
            style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }}
          />
          <textarea
            value={text}
            onChange={e => setText(e.target.value)}
            placeholder="Опишите проблему или предложение..."
            rows={5}
            style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC', resize: 'vertical' }}
          />
          <button
            onClick={submit}
            disabled={!text.trim()}
            style={{ padding: 12, background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, opacity: text.trim() ? 1 : 0.5 }}
          >
            Отправить
          </button>
        </div>
      )}
    </div>
  );
}

export default Feedback;